import React, { useState, useEffect } from "react";
import { get, postJSON } from "./fetchWrapper";

const fetchPendingVideo = () => get("/pending-video").then(res => res.json());

const approveVideo = id =>
  postJSON("/approve-video", { videoId: id }).then(res => res.json());

const rejectVideo = id =>
  postJSON("/reject-video", { videoId: id }).then(res => res.json());

const resetVideo = id =>
  postJSON("/reset-video", { videoId: id }).then(res => res.json());

const publishVideos = () => get("/process-new-videos").then(res => res.json());

export default () => {
  const [video, setVideo] = useState(null);

  const [approvals, setApprovals] = useState([]);
  const [publishedCount, setPublishedCount] = useState(0);
  const approvedCount = approvals.filter(a => a.approved === true).length;
  const rejectedCount = approvals.filter(a => a.rejected === true).length;

  useEffect(() => {
    fetchPendingVideo().then(pendingVideo => {
      if (!pendingVideo.url) {
        setVideo(null);
      } else {
        setVideo(pendingVideo);
      }
    });
  }, [approvals]);

  useEffect(() => {
    const eventHandler = event => {
      if (approvedCount > 0) {
        event.returnValue = `Your videos may not be published. Are you sure you want to leave?`;
      }
    };
    window.addEventListener("beforeunload", eventHandler);
    return () => {
      window.removeEventListener("beforeunload", eventHandler);
    };
  }, [approvedCount]);

  const handleRejectClick = async () => {
    const result = await rejectVideo(video.id);
    if (result.success) {
      setApprovals([
        { id: video.id, rejected: true, approved: false },
        ...approvals
      ]);
      setPublishedCount(0);
      fetchPendingVideo().then(pendingVideo => setVideo(pendingVideo));
    }
  };

  const handleApproveClick = async () => {
    const result = await approveVideo(video.id);
    if (result.success) {
      setApprovals([
        { id: video.id, rejected: false, approved: true },
        ...approvals
      ]);
      setPublishedCount(0);
      fetchPendingVideo().then(pendingVideo => setVideo(pendingVideo));
    }
  };

  const handleUndoClick = async () => {
    const result = await resetVideo(approvals[0].id);
    if (result.success) {
      setApprovals(approvals.slice(1));
      fetchPendingVideo().then(pendingVideo => setVideo(pendingVideo));
    }
  };

  const handlePublishClick = async () => {
    const result = await publishVideos();

    console.log("result", result);

    if (result.success) {
      setPublishedCount(approvedCount);
      setApprovals([]);
    }
  };

  return (
    <div className="Approval">
      <div className="Approval-preview">
        <h1>Video Review</h1>
        <div style={{ width: "70%" }}>
          {video ? (
            <video src={video.url} className="Video-canvas" controls></video>
          ) : (
            <p>There are no videos to review at this time. :-)</p>
          )}
        </div>
      </div>
      <div className="Approval-data">
        <p>
          <b>Videos to Review:</b> {video ? video.count : 0}{" "}
        </p>
        {publishedCount > 0 ? (
          <p>You just published {publishedCount} videos!</p>
        ) : null}
        <p>
          <b>Approved Videos:</b> {approvedCount}
        </p>
        <p>
          <b>Rejected Videos:</b> {rejectedCount}
        </p>
      </div>
      <div className="Approval-buttons">
        <button onClick={handlePublishClick}>Publish Videos</button>
        <button onClick={handleRejectClick} style={{ borderColor: "red" }}>
          Reject
        </button>
        <button
          onClick={handleApproveClick}
          style={{ backgroundColor: "green", color: "white" }}
        >
          Approve
        </button>
        <button
          onClick={handleUndoClick}
          style={{ backgroundColor: "white", color: "black" }}
        >
          Undo
        </button>
      </div>
    </div>
  );
};
